import MapView from "../components/common/MapView";

import { useEffect, useState } from "react";
import { useApiFetch } from "src/lib/api";
// [tutorial disabled] import { driver } from "driver.js";
// [tutorial disabled] import "driver.js/dist/driver.css";
import "../styles/Home.css";
import "../styles/common/DriverCustom.css";

export default function IndexPage() {
  const apiFetch = useApiFetch();
  const [orgName, setOrgName] = useState([]);
  // [tutorial disabled] const [tutorial, setTutorial] = useState(true);

  // [tutorial disabled] const disableTutorial = async () => {
    // [tutorial disabled] try {
      // [tutorial disabled] await apiFetch("/auth/disable-tutorial", { method: "POST" });
    // [tutorial disabled] } catch (error) {
      // [tutorial disabled] console.error("Error disabling tutorial:", error);
    // [tutorial disabled] }
  // [tutorial disabled] };

  // [tutorial disabled] /* Definition of driver.js */
  // [tutorial disabled] const driverObj = driver({
    // [tutorial disabled] steps: [
      // [tutorial disabled] {
        // [tutorial disabled] element: '#org-space',
        // [tutorial disabled] popover: {
          // [tutorial disabled] title: 'Organization Workspace',
          // [tutorial disabled] description: 'This is the organization workspace',
          // [tutorial disabled] prevBtnText:  `
            // [tutorial disabled] <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              // [tutorial disabled] <path d="M15 18l-6-6 6-6" />
            // [tutorial disabled] </svg>
          // [tutorial disabled] `,
          // [tutorial disabled] doneBtnText:  `
              // [tutorial disabled] <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                // [tutorial disabled] <path d="M9 18l6-6-6-6" />
              // [tutorial disabled] </svg>
            // [tutorial disabled] `,
          // [tutorial disabled] onNextClick: () => {
            
            // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "mapView");
          // [tutorial disabled] },
          // [tutorial disabled] onCloseClick: () => {
            // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
            // [tutorial disabled] driverObj.destroy();
            // [tutorial disabled] disableTutorial();
          // [tutorial disabled] }
        // [tutorial disabled] },
        // [tutorial disabled] onDeselected: () => {
          // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
          // [tutorial disabled] disableTutorial();
        // [tutorial disabled] },
        // [tutorial disabled] onDestroyed: () => {
          // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
          // [tutorial disabled] disableTutorial();
        // [tutorial disabled] },
        // [tutorial disabled] onHighlighted: () => {
          // [tutorial disabled] const enablePrev = () => {
            // [tutorial disabled] const prevBtn = document.querySelector('.driver-popover-prev-btn');
            // [tutorial disabled] if (prevBtn) {
              // [tutorial disabled] prevBtn.removeAttribute("disabled");
              // [tutorial disabled] prevBtn.classList.remove('driver-popover-btn-disabled');
              // [tutorial disabled] clearInterval(retry); // Detener intentos
            // [tutorial disabled] }
          // [tutorial disabled] };

          // [tutorial disabled] const retry = setInterval(enablePrev, 100);
          // [tutorial disabled] // opcionalmente corta después de 1s si no se logra
          // [tutorial disabled] setTimeout(() => clearInterval(retry), 1000);
        // [tutorial disabled] },
      // [tutorial disabled] }
    // [tutorial disabled] ]
  // [tutorial disabled] });

  // [tutorial disabled] /* Display tour tutorial */
  // [tutorial disabled] useEffect(() => {
  // [tutorial disabled] let intervalId = null;

  // [tutorial disabled] const checkForTutorialReady = () => {
    // [tutorial disabled] let step = localStorage.getItem("driver-tutorial-step");
    // [tutorial disabled] const el = document.querySelector("#org-space");

    // [tutorial disabled] if (step === "org-space" && el) {
      // [tutorial disabled] clearInterval(intervalId); // limpiar el polling
      // [tutorial disabled] startDriver(); // lanzar el tour

      // [tutorial disabled] setTimeout(() => {
        // [tutorial disabled] intervalId = setInterval(checkForTutorialReady, 300);
      // [tutorial disabled] }, 1000);
    // [tutorial disabled] }
  // [tutorial disabled] };

  // [tutorial disabled] const startDriver = () => {
    // [tutorial disabled] const driverObj = driver({
      // [tutorial disabled] steps: [
        // [tutorial disabled] {
          // [tutorial disabled] element: '#org-space',
          // [tutorial disabled] popover: {
            // [tutorial disabled] title: 'Organization Workspace',
            // [tutorial disabled] description: 'This is the organization workspace',
            // [tutorial disabled] prevBtnText:  `
              // [tutorial disabled] <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                // [tutorial disabled] <path d="M15 18l-6-6 6-6" />
              // [tutorial disabled] </svg>
            // [tutorial disabled] `,
            // [tutorial disabled] doneBtnText:  `
                // [tutorial disabled] <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  // [tutorial disabled] <path d="M9 18l6-6-6-6" />
                // [tutorial disabled] </svg>
              // [tutorial disabled] `,
            // [tutorial disabled] onNextClick: () => {
              // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "mapView");
            // [tutorial disabled] },
            // [tutorial disabled] onCloseClick: () => {
              // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
              // [tutorial disabled] driverObj.destroy();
              // [tutorial disabled] disableTutorial();
            // [tutorial disabled] }
          // [tutorial disabled] },
          // [tutorial disabled] onDeselected: () => {
            // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
            // [tutorial disabled] disableTutorial();
          // [tutorial disabled] },
          // [tutorial disabled] onDestroyed: () => {
            // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
            // [tutorial disabled] disableTutorial();
          // [tutorial disabled] },
          // [tutorial disabled] onHighlighted: () => {
            // [tutorial disabled] const enablePrev = () => {
              // [tutorial disabled] const prevBtn = document.querySelector('.driver-popover-prev-btn');
              // [tutorial disabled] if (prevBtn) {
                // [tutorial disabled] prevBtn.removeAttribute("disabled");
                // [tutorial disabled] prevBtn.classList.remove('driver-popover-btn-disabled');
                // [tutorial disabled] clearInterval(retry); 
              // [tutorial disabled] }
            // [tutorial disabled] };

            // [tutorial disabled] const retry = setInterval(enablePrev, 100);
            // [tutorial disabled] setTimeout(() => clearInterval(retry), 1000);
          // [tutorial disabled] },
        // [tutorial disabled] }
      // [tutorial disabled] ]
    // [tutorial disabled] });

    // [tutorial disabled] driverObj.drive();
  // [tutorial disabled] };

  // [tutorial disabled] intervalId = setInterval(checkForTutorialReady, 300);

  // [tutorial disabled] return () => {
    // [tutorial disabled] if (intervalId) clearInterval(intervalId);
  // [tutorial disabled] };
  // [tutorial disabled] }, []);

  useEffect(() => {
    const fetchOrgName = async () => {
      try {
        const data = await apiFetch("/auth/auth-org-name");
        if (!data) return;
        setOrgName(data?.name ?? "");
      } catch (error) {
        console.error("Fetch error:", error);
      }
    };

    fetchOrgName();
  }, [apiFetch]);

  // [tutorial disabled] const fetchTutorial = async () => {
    
    // [tutorial disabled] try {
      // [tutorial disabled] const data = await apiFetch("/auth/tutorial");
      // [tutorial disabled] if (!data) return;
      // [tutorial disabled] setTutorial(data?.tutorial);
      // [tutorial disabled] if (data?.tutorial) {
        // [tutorial disabled] driverObj.drive();
      // [tutorial disabled] }
    // [tutorial disabled] } catch (error) {
      // [tutorial disabled] console.error("Fetch error:", error);
    // [tutorial disabled] }
  // [tutorial disabled] };

  // [tutorial disabled] useEffect(() => {
    // [tutorial disabled] fetchTutorial();
  // [tutorial disabled] }, []);

  return (
    <div className="dashboard-container home-page">
      <div id="org-space" className="ml-2">{orgName && <h2> {orgName} 's Space</h2>}</div>
      <MapView />
    </div>
  );
}